var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-with-title" },
    [
      _vm.title
        ? _c(
            "div",
            { staticClass: "title", class: { centered: _vm.centerTitle } },
            [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "loading" }, [
            _vm._v(_vm._s(_vm.$t("loading"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }